<template>
    <v-container>
        <v-row dense>
            <v-col cols="12">
                <v-card color="#C0D5ED" dark>
                    <v-row>
                        <v-col cols="8">
                            <v-card-title class="titulopagina">REPORTE DE PRODUCCION CONSOLIDADA</v-card-title>
                        </v-col>
                        <v-col cols="1">
                            <v-btn color="green darken-1" class="float-right" small dark @click="cargarProduccionConsolidada()"><v-icon>loop</v-icon></v-btn>
                        </v-col>
                        <v-col cols="3">
                            <date-picker v-model="fecha" placeholder ="Seleccione Fecha" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD" class="float-right mr-1"></date-picker>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>

            <v-col cols="12">
                <v-card color="white" dark>
                    <v-card-title class="linea">
                        TOTALES
                    </v-card-title>
                    <v-card-actions>
                        <v-col>
                            <v-row>
                                <v-col><span class="harina">HARINA</span></v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-card>
                                        <v-simple-table dense>
                                            <thead>
                                                <tr>
                                                    <th class="cabecera">Totales</th>
                                                    <th class="cabecera">total Maxisacos Consolidado</th>
                                                    <th class="cabecera">Total kilos Consolidado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="total in resumen_harina" :key="total.id">
                                                    <td>{{total.nombre}}</td>
                                                    <td>{{total.cantidad_jumbos}}</td>
                                                    <td>{{total.total_kilos}}</td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col>
                            <v-row>
                                <v-col><span class="aceite">ACEITE</span></v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-card>
                                        <v-simple-table dense>
                                            <thead>
                                                <tr>
                                                    <th class="cabecera">Totales</th>
                                                    <th class="cabecera">Total Litros Consolidado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{resumen_aceite.nombre}}</td>
                                                    <td>{{resumen_aceite.total_litros_consolidado}}</td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" v-for="(l) in items" :key="l.id" class="ml-1 mr-1">
                <v-card color="white" dark>
                    <v-card-title class="linea">
                        {{ l.nombre_linea }}
                    </v-card-title>
                    <v-card-actions>

                        <v-row class="ml-1 mr-1">
                            <v-card>
                                <v-simple-table dense>
                                    <thead>
                                        <tr class="cabecera-verde">
                                            <th>Materia Prima Sin Restricción</th>
                                            <th>Materia Prima Con Restricción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="l.detalle_produccion_dia">
                                            <td>{{l.detalle_produccion_dia.mp_procesada_aprox}}</td>
                                            <td>{{l.detalle_produccion_dia.mp_procesada_con_restriccion}}</td>
                                        </tr>
                                        
                                    </tbody>
                                </v-simple-table>
                            </v-card>
                        </v-row>

                        <v-row class="ml-1 mr-1">
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <span class="harina">HARINA</span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-card>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th class="cabecera">Lote</th>
                                                        <th class="cabecera">Cant. Maxi. Consolidado</th>
                                                        <th class="cabecera">Kilos Consolidado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="lo in l.lotes" :key="lo.id">
                                                        <td class="text-center">{{lo.nombre_lote}}</td>
                                                        <td class="text-center">{{lo.cantidad_jumbos_consolidado}}</td>
                                                        <td class="text-center">{{lo.total_kilos_consolidado}}</td>
                                                    </tr>
                                                    
                                                </tbody>
                                            </v-simple-table>

                                            
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-row class="mt-2">
                                    <v-col>
                                        <v-card>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th class="sub-cabecera">Subtotal</th>
                                                        <th class="sub-cabecera">Cantidad Maxisacos</th>
                                                        <th class="sub-cabecera">Kilos</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr :class="resumen.clase" v-for="resumen in l.subtotal_lotes" :key="resumen.id">
                                                        <td class="text-center">{{resumen.nombre_lote}}</td>
                                                        <td class="text-center">{{resumen.cantidad_jumbos}}</td>
                                                        <td class="text-center">{{resumen.kilos_jumbos}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <span class="aceite">ACEITE</span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-card>
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th class="cabecera">Estanque</th>
                                                        <th class="cabecera">Litros Consolidado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="e in l.estanques" :key="e.id">
                                                        <td>{{e.codigo}}</td>
                                                        <td>{{e.produccion_consolidada}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
export default {
    data:()=>({
        fecha:null,
        items:[],
        resumen_harina:[],
        resumen_aceite:{}
    }),
    mounted() {
        this.fecha = this.moment().format('YYYY-MM-DD');
        this.cargarProduccionConsolidada();
    },
    methods: {
        async cargarProduccionConsolidada(){
            //this.mostrarLoading('Cargando Producción Consolidada...');
            this.mostrarLoading({titulo:'Cargando Producción Consolidada...',color:'green'})

            await this.axios.get(`${this.base_url}produccion/consolidada/${this.fecha}`,this.headers).then((res)=>{
                console.log('items',res.data);
                this.items = res.data.data;
                this.resumen_harina = res.data.resumen_harina?res.data.resumen_harina:[];
                this.resumen_aceite = res.data.resumen_aceite?res.data.resumen_aceite:[];
                this.ocultarLoading();
            }).catch((e)=>{
                console.log('error',e);
                this.ocultarLoading();
            });
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker
    }
}
</script>
<style scoped>
    .col{
        padding: 5px 12px;
    }
    .reproceso{
        background-color: #ffeac4;
    }
    .produccion{
        background-color: #E8F5E9;
    }
    .cabecera-verde{
        background-color: #008000 !important;
    }
    table tr td{
        border-right: thin solid rgba(0, 0, 0, 0.12);
        background-color: #6D8DB7;
        color: #000;
    }
    table tr th{
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }
    .harina{
        background-color:#84B0DA;color:#000 !important; padding:0.2em 0.8em; border-radius:1em;
    }
    .aceite{
        background-color:#6D8DB7;color:#000 !important; padding:0.2em 0.8em; border-radius:1em;
    }
    .linea{
        background-color:#6D8DB7;color:#000 !important; padding:0.3em 0.5em; border-radius:0.5em;
    }

</style>